export default __webpack_public_path__ + "static/media/security.3fcaad7a.webp";